// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"su_a bht_rc bht_qx bht_xr","ForumPosts__contest":"su_b bht_hq","ForumPosts__counselling":"su_c"};